import { getApi, postApi, putApi } from "../apiCall";

export const loginService = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/auth/login/public`;
  return postApi(url, payload);
};

export const loginSwitchService = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/auth/switchLogin`;
  return postApi(url, payload);
};

export const emailValidateion = (userName) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/onboarding/validateEmail/public?email=shubhamanuj652%40gmail.com&otp=3xcvfd`;
  return getApi(url, {}, true);
};

export const sentOTP = (email) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/onboarding/sendOtp/public?email=${email}`;
  return getApi(url, {}, true);
};

export const verifyOTP = (credential, otp, type) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/onboarding/validateEmail/public?credential=${credential}&otp=${otp}`;
  if (type) {
    url += `&type=${type}`;
  }
  return getApi(url, {}, true);
};

export const verifyUserName = (userName) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/onboarding/validateUserName/public?userName=${userName}`;
  return getApi(url, {}, true);
};

export const verifyCompanyDisplayName = (displayName) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/onboarding/validateCompanyDisplayName/public?companyDisplayName=${displayName}`;
  return getApi(url, {}, true);
};

export const verifyGeneratorName = (genName) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/onboarding/validateGeneratorName/public?generatorName=${genName}`;
  return getApi(url, {}, true);
};

export const verifyConsumerName = (conName) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/onboarding/validateConsumerName/public?consumerName=${conName}`;
  return getApi(url, {}, true);
};

export const userOnboarding = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/onboarding/signup/public`;
  return postApi(url, payload);
};

export const uploadAuthDocument = (formData) => {
  let url = `http://localhost:9191/doc/upload/public/random/AUTH`;
  return postApi(url, formData, {}, false);
};

export const sendOtpForPasswordUpdate = (credential) => {
  const url = `${process.env.REACT_APP_API_URL}/authorization/auth/update-password/send-otp/public?credential=${credential}`;
  return postApi(url, {});
};

export const verifyOtpForPasswordUpdate = (credential, otp) => {
  const url = `${process.env.REACT_APP_API_URL}/authorization/auth/update-password/verify-otp/public?credential=${credential}&otp=${otp}`;
  return putApi(url, {});
};

export const updatePassword = (credential, password) => {
  const url = `${
    process.env.REACT_APP_API_URL
  }/authorization/auth/update-password?credential=${credential}&null=null&password=${encodeURIComponent(
    password
  )}`;
  return putApi(url, {});
};
